const KNOWN_PLUGINS: Record<string, string> = {
  worldedit: "WorldEdit",
  fastasyncworldedit: "FastAsyncWorldEdit",
  fawe: "FAWE",
  worldguard: "WorldGuard",
  luckperms: "LuckPerms",
  essentials: "Essentials",
  essentialsx: "EssentialsX",
  protocollib: "ProtocolLib",
  vault: "Vault",
  placeholderapi: "PlaceholderAPI",
  coreprotect: "CoreProtect",
  dynmap: "Dynmap",
  geyser: "Geyser",
  floodgate: "Floodgate",
  viaversion: "ViaVersion",
  viabackwards: "ViaBackwards",
  viarewind: "ViaRewind",
  citizens: "Citizens",
  multiverse: "Multiverse",
  multiversecore: "Multiverse-Core",
  clearlag: "ClearLag",
  voicechat: "Simple Voice Chat",
  fabricapi: "Fabric API",
  chunky: "Chunky",
  authme: "AuthMe Reloaded",
  skinsrestorer: "SkinsRestorer",
  discordsrv: "DiscordSRV",
  griefprevention: "GriefPrevention",
  towny: "Towny",
  holographicdisplays: "HolographicDisplays",
  decentholograms: "DecentHolograms",
  spark: "spark",
  gsit: "GSit",
  chunkyborder: "ChunkyBorder",
};

export function pluginDisplayName(filename: string): string {
  if (!filename) {
    return "";
  }
  let base = filename.replace(/\.(jar|zip)$/i, "");
  base = base.replace(
    /[-_](bukkit|spigot|paper|fabric|forge|neoforge|sponge|velocity|bungeecord|bungee|dist|all)/gi,
    "",
  );
  base = base.replace(/[-_+](v?\d+(\.[\w\d]+)*.*)$/i, "");
  base = base.replace(
    /[-_](bukkit|spigot|paper|fabric|forge|neoforge|sponge|velocity|bungeecord|bungee|dist|all)$/gi,
    "",
  );

  const cleanKey = base.toLowerCase().replace(/[^a-z0-9]/g, "");
  if (cleanKey && KNOWN_PLUGINS[cleanKey]) {
    return KNOWN_PLUGINS[cleanKey];
  }

  if (/[a-z]/.test(base) && /[A-Z]/.test(base) && !/[-_]/.test(base)) {
    return base;
  }

  const words = base.split(/[-_]+/).filter(Boolean);
  if (words.length > 0) {
    return words
      .map((w) => {
        const lower = w.toLowerCase();
        if (lower === "api") {
          return "API";
        }
        if (lower === "mc") {
          return "MC";
        }
        if (lower === "gui") {
          return "GUI";
        }
        return w.charAt(0).toUpperCase() + w.slice(1);
      })
      .join(" ");
  }

  return base || filename;
}
